<template>
  <v-dialog v-model="show" persistent max-width="600">
    <v-card :class="multiLine ? 'delete-confirm': ''">
      <v-container class="pa-8">
        <v-row justify="center" class="mt-8">
          <div class="logout-text ml-2">
            <v-icon width="28" height="28" class="confirm-dialog-icon pr-2">{{
              icon
            }}</v-icon>
            <template v-if="!multiLine">
              {{ text }}
            </template>
            <template v-else>
              <p v-for="(item, index) in multiLineTexts" :key="index">
                {{ item }}
              </p>
            </template>
          </div>
        </v-row>
        <v-row justify="center" class="mt-8">
          <v-btn
            large
            class="button-size btn-lg-cancel ma-5"
            dark
            @click="cancel"
          >
            {{ cancelText }}
          </v-btn>
          <v-btn large class="button-size btn-lg-yes ma-5" dark @click="yes">
            {{ confirmText }}
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    icon: String,
    iconColor: String,
    text: String,
    show: Boolean,
    cancelText: {
      default: "キャンセル",
      type: String
    },
    confirmText: {
      default: "はい",
      type: String
    },
    multiLine: {
      default: false,
      type: Boolean
    },
    multiLineTexts: Array
  },
  methods: {
    yes() {
      this.$emit("yes");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss"  scoped>
.v-icon.v-icon.confirm-dialog-icon {
  align-items: start;
  display: block;
}
.confirm-dialog-icon {
  color: $orange !important;
}
.logout-text {
  font-size: $size-page-sub-title;
  color: $color-text;
  display: flex;
}
.delete-confirm {
.logout-text {
  display: block !important;
}
.v-icon.v-icon.confirm-dialog-icon {
    position: absolute !important;
    left: 14% !important;
}
}
.btn-lg-cancel {
  background-color: $user-cancel-color !important;
}
.btn-lg-yes {
  background-color: $user-primary !important;
}
/* Mobile */
@media screen and (max-width: $size-mobile) {
  .confirm-dialog-icon {
    margin-top: 0;
  }
  .logout-text {
    font-size: 17px;
  }
  .delete-confirm .v-icon.v-icon.confirm-dialog-icon[data-v-47876324] {   
    display: flex !important;
    justify-content: center !important;
    position: relative !important;
    left: auto !important
}
}
/* ThemeAdmin */
.ThemeAdmin {
  .btn-lg-cancel {
    background-color: $admin-cancel-color !important;
  }
  .btn-lg-yes {
    background-color: $admin-secondary !important;
  }
}
</style>
